var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientsEnableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6769 21.5984C19.6769 19.4776 16.9116 17.7584 13.5005 17.7584C10.0893 17.7584 7.32399 19.4776 7.32399 21.5984M24.6181 17.759C24.6181 16.1843 23.0936 14.831 20.9122 14.2384M2.38281 17.759C2.38281 16.1843 3.90729 14.831 6.08869 14.2384M20.9122 9.10065C21.6703 8.39753 22.1475 7.37572 22.1475 6.23844C22.1475 4.11767 20.4884 2.39844 18.4416 2.39844C17.4924 2.39844 16.6267 2.76817 15.971 3.37622M6.08869 9.10065C5.33053 8.39753 4.8534 7.37572 4.8534 6.23844C4.8534 4.11767 6.51259 2.39844 8.55928 2.39844C9.50842 2.39844 10.3742 2.76817 11.0299 3.37622M13.5005 13.9184C11.4537 13.9184 9.79458 12.1993 9.79458 10.0784C9.79458 7.95767 11.4537 6.23844 13.5005 6.23844C15.5472 6.23844 17.2063 7.95767 17.2063 10.0784C17.2063 12.1993 15.5472 13.9184 13.5005 13.9184Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsEnableIcon);
export default __webpack_public_path__ + "static/media/ClientsEnableIcon.8a6a15039f4dccb9de7a54138a912070.svg";
export { ForwardRef as ReactComponent };